

import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table } from "react-bootstrap";
import { imageRender, thousandSeperate } from "../../../helpers";
import PaginationsV1 from "../../../components/PaginationV1";

function LiveDetailSummary({ postDetailSummary, liveData, totalOrder, page, rowsPerPage, pageAll, handleChangePage }) {
    const [liveProductSummary, setLiveProductSummary] = useState([]);

    useEffect(() => {
        modifyData();
    }, [postDetailSummary])

    const modifyData = async () => {


        let _liveProductSummary = []

        // set post detail summary 
        _liveProductSummary = postDetailSummary.map((orders) => {
            return {
                // image: orders[0]?.liveStock?.stock?.image ?? null,
                stock: orders[0]?.liveStock?.stock ?? {},
                count: orders?.reduce((sumAmount, order) => {
                    return sumAmount + order?.amount
                }, 0),
                price: orders[0]?.price,
                // price: orders.map((order) => { return order?.price ?? 0 }).join(', '),
                totalPrice: orders?.reduce((sumPrice, order) => {
                    return sumPrice + (order?.amount * order?.price)
                }, 0),
                currency: orders[0]?.currency ?? 'ກີບ',
                cfMessage: orders[0]?.cfMessage
                // cfMessage: orders?.map((order) => { return order?.cfMessage }).join(', ')
            }
        })

        setLiveProductSummary(_liveProductSummary)
 
    }

    return (
        <div> 
            <div style={{ background: "#fff", borderRadius: 5, padding: 12 }}>
                <p style={{ fontSize: 20, margin: 0 }}>ລາຍການສິນຄ້າທີ່ຂາຍໄດ້</p>
                    <Table responsive className="staff-table-list borderless table-hover">
                        <thead style={{ background: "#F1F1F1", whiteSpace: 'nowrap' }}>
                            <tr>
                                <th style={{ borderBottom: "none" }}>ລ/ດ</th>
                                <th style={{ borderBottom: "none" }}>ຮູບ</th>
                                <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ</th>
                                <th style={{ borderBottom: "none" }}>ລະຫັດ CF</th>
                                <th style={{ borderBottom: "none" }}>ຂາຍໄດ້</th>
                                <th style={{ borderBottom: "none" }}>ລາຄາ</th>
                                <th style={{ borderBottom: "none" }}>ລວມເງິນ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {liveProductSummary && liveProductSummary?.map((lStock, index) => {
                                return <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td><img src={imageRender(lStock?.stock?.image)} style={{
                                        borderRadius: "50%",
                                        height: 50,
                                        width: 50,
                                    }} /></td>
                                    <td>
                                        <pre style={{ fontWeight: "bold", fontSize: 14, margin: 0 }}>
                                            {lStock?.stock?.name}
                                        </pre>
                                        {lStock?.stock?.optionValues?.length > 0 &&
                                            lStock?.stock?.optionValues.map((dd, kIndex) => <pre key={"option" + kIndex + index} style={{ margin: 0, fontSize: 12 }}>{dd.name + ':' + dd.value}</pre>)
                                        }
                                    </td>
                                    <td>{lStock?.cfMessage}</td>
                                    <td>{lStock?.count ?? 1}</td>
                                    <td>{thousandSeperate(lStock?.price ?? lStock?.stock?.price)}</td>
                                    <td>{thousandSeperate(lStock?.totalPrice ?? 0)} {lStock?.currency}</td>
                                </tr>
                            })}
                        </tbody>
                    </Table> 
                    
                    <PaginationsV1
                    count={totalOrder}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    pageAll={pageAll}
                    onPageChange={handleChangePage}
                />


            </div >

            <div style={{ height: 100 }} />
        </div >
    );
}

export default LiveDetailSummary;